<template>
  <DefaultPage>
    <TextGraphicSection id="our-core-value"
                        title="Our Core Value"
                        subtext="focused on you and what lies ahead"
                        videoId="397238540">
      <template v-slot:bodyText>
        Our focus in 1975 as a group of like-minded doctors was looking out for one another. It's still our core focus
        now. SVMIC is there at a moment’s notice to step up and lead our members through troubling times. Our
        collaborative claims process between you, the insured physician, in-house attorneys, and local defense attorneys
        is designed to help our valued members be ready for what lies ahead.
      </template>
    </TextGraphicSection>
    <TextGraphicSection id="listening-to-members"
                        title="Listening to Members"
                        subtext="it’s good to hear your voice"
                        videoId="397238516"
                        flipped>
      <template v-slot:bodyText>
        We use every available resource to provide insight and expertise in the defense of good medicine and good
        doctors. Above all our resources, we prize the expertise and knowledge of our policyholders. Our goal for Forum
        is to improve our value to members by listening to your perspectives and feedback on issues facing today’s
        medical professionals.
      </template>
    </TextGraphicSection>
    <TextGraphicSection id="building-resources"
                        title="Building Resources"
                        subtext="tools for today and tomorrow"
                        videoId="397238508">
      <template v-slot:bodyText>
        We share an obligation to help our doctors reduce their risk and protect their practices. With a record of
        shared success, education resources, a loyalty program (MVP), and online assessments on our evolving digital
        platform, Vantage&trade;, we bring the latest practice management knowledge and unmatched value to the doctors
        that we protect and support.
      </template>
    </TextGraphicSection>
    <TextGraphicSection id="what-our-members-are-saying"
                        title="What our Members are Saying"
                        videoId=""
                        flipped>
      <template v-slot:bodyText>
        <QuotesTabs :quotes="$options.quotes"/>
      </template>
      <template v-slot:photo>
        <img
          src="../assets/smiling-doctor.jpg"
          alt="Doctor"
          class="panel-cell__photo-content"/>
      </template>
    </TextGraphicSection>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TextGraphicSection from '@/components/section/TextGraphicSection';
import QuotesTabs from '@/components/tab/QuotesTabs';

const quotes = [
  {
    text: 'You realize after speaking with the SVMIC attorneys that they’re the cream of the crop. ' +
      'You can’t ask for more than that when you’re in trouble.',
    author: {
      name: 'Dr. Marcia Bowden',
      location: 'Bowden Internal Medicine'
    }
  },
  {
    text: 'Some of my questions for SVMIC are big and some are small, but I always get the answer I need quickly.',
    author: {
      name: 'Dr. James Wang',
      location: 'Tri-State Neurology'
    }
  },
  {
    text: 'They almost always have someone that I can speak to that is knowledgable of my specialty. ' +
      'That’s not always easy to do.',
    author: {
      name: 'Dr. Samuel C. Polk',
      location: 'Semmes Murphey Clinic'
    }
  }
];

export default {
  name: 'Focus',
  components: { QuotesTabs, TextGraphicSection, DefaultPage },
  quotes: quotes
};
</script>

<style lang="scss" scoped>
  @import "../styles/setup/variables.scss";

  .quote__signature {
    color: $purp;
    padding-top: 40px;

    .signature__name {
      font-weight: 600;
      font-family: $sans-serif;
      font-size: 20px;
      letter-spacing: 3px;
      text-transform: uppercase;
    }
  }

  .quote__page-selector {
    padding-top: 20px;

    span {
      margin: 0 10px;
      color: $light-blue;
      font-weight: 800;
      cursor: pointer;
    }

    .current {
      border-bottom: 3px solid $light-blue;
    }
  }
</style>
